<div class="row align-items-center">
  <div [ngClass]="{ 'col-5': showTariff, 'col-12': !showTariff }">
    <div class="text-center">
      <mwe-product-icon [category]="product.category" size="lg" [textNodeType]="headlineService.getHeadline(0)" />
    </div>
  </div>

  @if (showTariff) {
    <div class="col-7 pl-0 pr-4 text-start my-auto">
      <mwe-product-card-tariff-list
        [product]="product"
        [showWaermeTariffClassesAsideOfIcon]="showWaermeTariffClassesAsideOfIcon"
        [tariffClasses]="tariffClasses$ | async"
      />
      @if (accountNrLabel) {
        <p class="product-account mb-1" [translate]="accountNrLabel" [translateParams]="translateParams" data-test="card-account-nr"></p>
      }
      @if (showTariffDetailsLink) {
        <mwe-button-link [url]="getTariffDetailsLink()" label="tariff.tariffDetails" customCss="expander-item-btn-fix" />
      }
    </div>
  }
</div>
@if (showTariffDetails && tariffIndication) {
  <div>
    <hr class="my-4" />
    @if (showPrices) {
      <div class="text-uppercase text-secondary fw-bold mb-2" translate="tariff.details.prices"></div>
    }
    @if (showPrices && tariffIndication?.grundpreis) {
      <div class="row mb-2">
        <div class="col col-sm hyphenate">
          <p class="text--big mb-0" [translate]="basePriceKey"></p>
          @if (tariffIndication?.grundpreisIconInfoText) {
            <mwe-info-text-icon [infoTextDescription]="tariffIndication.grundpreisIconInfoText" [infoTextTitle]="grundpreisLabel">
            </mwe-info-text-icon>
          }
        </div>
        <div class="col col-sm hyphenate">
          <p
            class="text--big mb-0"
            data-test="wizard-product-card-grundpreis"
            [translate]="grundpreisLabel"
            [translateParams]="{ value: tariffIndication?.grundpreis, pricePeriod: tariffIndication?.grundpreisUnit }"
          ></p>
        </div>
      </div>
    }
    @if (showPrices && tariffIndication?.arbeitspreis) {
      <div class="row mb-2">
        <div class="col col-sm hyphenate">
          <p class="text--big mb-0" translate="tariff.details.consumptionPrice"></p>
        </div>
        <div class="col col-sm">
          <p
            class="text--big mb-0"
            data-test="wizard-product-card-arbeitspreis"
            translate="tariff.details.arbeitspreis"
            [translateParams]="{ value: tariffIndication?.arbeitspreis, pricePeriod: tariffIndication?.arbeitspreisUnit }"
          ></p>
        </div>
      </div>
    }
    @if (showPrices && tariffIndication?.anschlusspreis) {
      <div class="row mb-2">
        <div class="col col-sm hyphenate">
          <p class="text--big mb-0" [translate]="installationPriceKey"></p>
        </div>
        <div class="col col-sm hyphenate">
          <p
            class="text--big mb-0"
            data-test="wizard-product-card-anschlusspreis"
            translate="tariff.details.anschlusspreis"
            [translateParams]="{ value: tariffIndication?.anschlusspreis, pricePeriod: tariffIndication?.anschlusspreisUnit }"
          ></p>
        </div>
      </div>
    }
    @for (info of tariffIndication?.preisInfos; track info) {
      <div class="row mb-2">
        <div class="col col-sm hyphenate">
          <p class="text--big mb-0">{{ info.text }}</p>
        </div>
        <div class="col col-sm hyphenate">
          <p class="text--big mb-0">{{ info.preis }}</p>
        </div>
      </div>
    }
    @if (isCategoryInternet && tariffIndication.vorteile?.length > 0) {
      <div class="row mb-2 mt-3 align-items-center">
        @for (vorteil of tariffIndication.vorteile; track vorteil) {
          <div class="row align-items-center">
            <div class="col-2 col-sm-2">
              <i class="fas fa-check-circle font-size-18 green"></i>
            </div>
            <div class="col col-sm pl-0">
              <p class="text--big mb-0">{{ vorteil }}</p>
            </div>
          </div>
        }
      </div>
    }
    @if (tariffBinding?.kurzWert || selectedTariffOptions?.length > 0) {
      <div class="text-uppercase text-secondary fw-bold mt-4 mb-2" translate="tariff.details.options"></div>
    }
    @if ((!selectedTariffOptions || selectedTariffOptions?.length === 0) && tariffBinding?.kurzWert) {
      <div class="row mb-2">
        <div class="col col-sm hyphenate">
          <p class="text--big mb-0" translate="tariff.details.binding"></p>
        </div>
        <div class="col col-sm">
          <p class="text--big mb-0">{{ tariffBinding?.kurzWert }}</p>
        </div>
      </div>
    }
    @if (!!selectedTariffOptions && selectedTariffOptions?.length > 0) {
      <div>
        @for (option of selectedTariffOptions; track option) {
          <div class="row mb-2">
            <div class="col col-sm hyphenate">
              <p class="text--big mb-0">{{ option.art }}:</p>
            </div>
            <div class="col col-sm" [attr.data-test]="'wizard-product-card-' + option.option">
              <p class="text--big mb-0" [innerHTML]="getLabelFrom(option)"></p>
            </div>
          </div>
        }
      </div>
    }
    @if (tariffIndication?.istRabattiert) {
      <mwe-alert
        class="d-block mt-4"
        type="success"
        messageKey="tariff.isDiscounted.text"
        [attr.data-test]="'new-client-summary-discount-' + product.category"
        [isMinimalLayout]="true"
        [infoText]="{ description: discountInfoPopupText, title: 'tariff.isDiscounted.infoIcon.title' }"
      />
    }
    @if (voucherInfo?.length > 0) {
      <div class="text-uppercase text-secondary fw-bold mt-4 mb-2" translate="tariff.details.voucherInfo"></div>
    }
    @if (voucherInfo?.length > 0) {
      <div>
        @for (voucher of voucherInfo; track voucher) {
          <div class="row mb-2">
            <div class="col col-sm">
              <p class="text--big mb-0">{{ voucher }}</p>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

@if (this.isCategoryFernwaerme && tariffClasses.length && !showWaermeTariffClassesAsideOfIcon) {
  <div>
    <hr class="my-4" />
    <mwe-headline [headlineLevelIncrement]="1" cssClass="fw-bold mb-2 text--big text-secondary" text="products.details.tariffList" />
    <mwe-product-card-tariff-list-fernwaerme [tariffClasses]="tariffClasses$ | async" />
  </div>
}
